const inprogressBoldLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><path d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12M11.25 5.003h1.502v6.243h6.244v1.508h-7.745z" clip-rule="evenodd"/></svg>',
};

export { inprogressBoldLarge as default };
